export const setElementData = (data) => ({
    type: 'SET_ELEMENT_DATA',
    payload: data,
  });
  